<app-report [paramsConfig]="['attributed_metric', 'channel', 'new_period_without_comparison']"
            [actionsConfig]="[]"
            [paramsDropdownConfig]="[]"
            helpTemplate="channel-affinity-report"
            [disableExports]="true"
            [disableDownloads]="true"
            [beta]="true"
            [iframe]="iframe$ | async"
            [enableDialogs]="true">
  <div actions>
    <app-button icon="settings"
                [disabled]="disabled$ | async"
                (onClick)="onSettings()">{{ 'button.parameters' | translate }}</app-button>
  </div>
  <app-jumbotron class="full-height full-width relative">
    <app-sankey></app-sankey>
  </app-jumbotron>
</app-report>
